import { Inject, Injectable } from '@angular/core';
import r7insight from 'r7insight_js/product/r7insight';
import { NgxComponentsConfig } from '@app/ngx-components/ngx-components.config';
/**
 * Logger type.
 */
export enum LoggerType {
  CONSOLE = 'console',
  LOG_ENTRIES = 'log_entries',
}

/**
 * Default module configuration.
 */
const defaultConfig: NgxComponentsConfig = {
  moduleName: 'ngx-components',
  logger: {},
};

@Injectable()
export class Logger {
  /**
   * Logger type.
   *
   * @private
   * @type {LoggerType}
   * @memberof Logger
   */
  private type: LoggerType;

  /**
   * Constructor
   *
   * @param {NgxComponentsConfig} moduleConfig
   */
  constructor(@Inject('config') private moduleConfig: NgxComponentsConfig = defaultConfig) {
    this.type =
      moduleConfig && moduleConfig.logger && moduleConfig.logger.type
        ? moduleConfig.logger.type
        : LoggerType.CONSOLE;
    if (this.type === LoggerType.LOG_ENTRIES) {
      this.initLogEntries();
    }
  }

  /**
   * Initializing log entries logger.
   */
  initLogEntries(): void {
    const config = {
      name: this.moduleConfig.moduleName || defaultConfig.moduleName,
      token: this.moduleConfig.logger.token,
      region: 'eu',
      catchall: true,
      ssl: true,
      page_info: 'per-page',
    };
    r7insight.init(config);
  }

  /**
   * Log error message.
   *
   * @param {string} message
   * @param {Error} error
   */
  public error(message: string, error?: Error): void {
    if (this.type === LoggerType.LOG_ENTRIES) {
      r7insight.error(message);
    } else {
      console.error(message);
    }
  }

  /**
   * Log message.
   *
   * @param {string} message
   */
  public log(message: string): void {
    if (this.type === LoggerType.LOG_ENTRIES) {
      r7insight.log(message);
    } else {
      console.log(message);
    }
  }

  /**
   * Log warnings.
   *
   * @param {string} message
   */
  public warn(message: string): void {
    if (this.type === LoggerType.LOG_ENTRIES) {
      r7insight.warn(message);
    } else {
      console.warn(message);
    }
  }

  /**
   * Log info messages.
   *
   * @param {string} message
   */
  public info(message: string): void {
    if (this.type === LoggerType.LOG_ENTRIES) {
      r7insight.info(message);
    } else {
      console.info(message);
    }
  }
}
